<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content content-with-nav pa-0"
    fluid
  >
    <!-- Hero section -->
    <page-hero
      title="Symboliek"
      intro="Zijn er familieleden of vrienden die een symbolische handeling willen uitvoeren?"
    />

    <!-- Content -->
    <v-row justify="center">
      <v-col
        class="center"
        cols="12"
        md="10"
        lg="8"
      >
        <v-table class="symboliek-table">
          <thead>
            <tr>
              <th style="width: 15%">
                Symbolische handeling
              </th>
              <th style="width: 35%">
                Wie doet dit?
              </th>
              <th style="width: 35%">
                Wat specifiek?
              </th>
              <th style="width: 15%">
                Wie voorziet de bloem(en)?
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="font-weight-bold">
                Een kaars aansteken
              </td>
              <td>
                <v-textarea
                  v-model="algemeneInfo.symboliekKaarsWie"
                  auto-grow
                  base-color="primary"
                  bg-color="white"
                  color="primary"
                  density="compact"
                  hide-details
                  rows="4"
                  variant="outlined"
                />
              </td>
              <td />
              <td />
            </tr>
            <tr>
              <td class="font-weight-bold">
                Een bloem neerleggen
              </td>
              <td>
                <v-textarea
                  v-model="algemeneInfo.symboliekBloemenWie"
                  auto-grow
                  base-color="primary"
                  bg-color="white"
                  color="primary"
                  density="compact"
                  hide-details
                  rows="4"
                  variant="outlined"
                />
              </td>
              <td>
                <v-textarea
                  v-model="algemeneInfo.symboliekBloemenWat"
                  auto-grow
                  base-color="primary"
                  bg-color="white"
                  color="primary"
                  density="compact"
                  hide-details
                  rows="4"
                  variant="outlined"
                />
              </td>
              <td>
                <v-select
                  v-model="algemeneInfo.symboliekBloemenLeverancierValue"
                  base-color="primary"
                  bg-color="white"
                  color="primary"
                  density="compact"
                  hide-details
                  item-title="longDescription"
                  item-value="value"
                  :items="symboliekAanleveringOpties"
                  variant="outlined"
                />
              </td>
            </tr>
            <tr>
              <td class="font-weight-bold">
                Knutselwerkje, ... aandragen
              </td>
              <td>
                <v-textarea
                  v-model="algemeneInfo.symboliekVoorwerpWie"
                  auto-grow
                  base-color="primary"
                  bg-color="white"
                  color="primary"
                  density="compact"
                  hide-details
                  rows="4"
                  variant="outlined"
                />
              </td>
              <td>
                <v-textarea
                  v-model="algemeneInfo.symboliekVoorwerpWat"
                  auto-grow
                  base-color="primary"
                  bg-color="white"
                  color="primary"
                  density="compact"
                  hide-details
                  rows="4"
                  variant="outlined"
                />
              </td>
              <td />
            </tr>
          </tbody>
        </v-table>
        <div class="d-flex justify-end mt-4 mb-8">
          <v-btn
            color="primary"
            rounded
            @click="SaveGeneralInfo"
          >
            <v-icon
              class="mr-1"
              size="18"
            >
              mdi-content-save-outline
            </v-icon>
            Opslaan
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <!-- Navigation -->
    <div class="samenstellen-nav">
      <div class="samenstellen-nav-inner">
        <v-btn
          v-if="samenstellenNavigation_PreviousItem"
          color="primary"
          :disabled="samenstellenNavigation_PreviousItem.disabled"
          rounded
          variant="text"
          @click="samenstellenNavigation_GoToPrevious"
        >
          <v-icon start>
            mdi-chevron-left
          </v-icon>
          {{ samenstellenNavigation_PreviousItem.title }}
        </v-btn>
        <span v-else />
        <v-btn
          v-if="samenstellenNavigation_NextItem"
          color="primary"
          :disabled="samenstellenNavigation_NextItem.disabled"
          rounded
          variant="text"
          @click="samenstellenNavigation_GoToNext"
        >
          {{ samenstellenNavigation_NextItem.title }}
          <v-icon end>
            mdi-chevron-right
          </v-icon>
        </v-btn>
        <span v-else />
      </div>
    </div>
  </v-container>
</template>

<script>
import PageHero from '@/components/PageHero.vue'
import authenticationMixin from '@/mixins/authenticationMixin'
import commonMixin from '@/mixins/commonMixin'
import constantMixin from '@/mixins/constantMixin'
import errorMixin from '@/mixins/errorMixin'
import samenstellenNavigationMixin from '@/mixins/samenstellenNavigationMixin'
import klantService from '@/services/klantService'

export default {
  name: 'SymboliekComponent',
  components: { PageHero },
  mixins: [
    authenticationMixin,
    commonMixin,
    constantMixin,
    errorMixin,
    samenstellenNavigationMixin
  ],
  data () {
    return {
      algemeneInfo: {},
      symboliekAanleveringOpties: []
    }
  },
  mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    this.$store.state.headers.samenstellen = true
    klantService.Init(this)
    this.LoadData()
  },
  beforeUnmount () {
    this.$store.state.headers.samenstellen = false
  },
  methods: {
    async LoadData () {
      this.CommonMixin_Load(this.$options.name, true)
      await Promise.all([
        this.GetSymboliekAanleveringOpties(),
        this.GetUitvaartSymboliek()
      ])
      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetSymboliekAanleveringOpties () {
      const resp = await klantService.GetUitvaartDraaiboekListCode()

      if (resp?.data) {
        this.symboliekAanleveringOpties = resp.data.filter(o => o.type === this.constantMixin.codes.symboliekAanlevering.name)
      }
    },
    async GetUitvaartSymboliek () {
      const resp = await klantService.GetUitvaartSymboliek()

      if (resp && (resp.data || resp.data !== '')) {
        this.algemeneInfo = resp.data
      }
    },
    async SaveGeneralInfo () {
      this.CommonMixin_Load(this.$options.name, true)
      await klantService.SaveUitvaartSymboliek(this.algemeneInfo)
      this.CommonMixin_Load(this.$options.name, false)
    }
  }
}
</script>

<style scoped>
.symboliek-table {
  background-color: transparent !important;
  border: 1px solid #e8e4dc;
  border-radius: 10px;
  overflow: hidden;
}

.symboliek-table td {
  padding: 8px !important;
  vertical-align: top;
  color: #424E58;
  font-size: 14px;
  border-bottom: 1px solid #e8e4dc;
}

.symboliek-table td:first-child {
  background-color: #fdfcfa;
}

.symboliek-table tr:last-child td {
  border-bottom: none;
}

.symboliek-table tr:nth-child(even) td {
  background-color: #FBF7EE;
}

.symboliek-table tr:nth-child(even) td:first-child {
  background-color: #f8f2e4;
}

.symboliek-table th {
  color: #907322 !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  background-color: #fdfcfa !important;
  border-bottom: 2px solid #DEC067 !important;
}
</style>
